import {defaultTemplate} from './DefaultTemplate'
import {defaultTemplateRTL} from './DefaultTemplateRTL'

export default {defaultTemplate, defaultTemplateRTL}